export default __webpack_public_path__ + "static/media/close_no_circle.f26d89c4.svg";